import React from "react";
import { Card, Carousel } from "flowbite-react";

export default function GaleryCorouselContent() {
  return (
    <div className="container flex justify-center items-center mt-20 mb-20">
      <div className="w-3/4">
        <div className="custom-height-carousel">
          <Carousel>
            <div className="w-full">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="col-span-1">
                  <div className="w-full">
                    <Card imgSrc={require("../../images/event-1.jpg")}>
                      <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        Lorem ipsum dolor sit amet.
                      </h5>
                      <p className="font-normal text-gray-700 dark:text-gray-400">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti reprehenderit cumque quos at fugiat inventore molestias culpa officiis quia tempora.
                      </p>
                    </Card>
                  </div>
                </div>

                <div className="col-span-1">
                  <div className="w-full">
                    <Card imgSrc={require("../../images/event-2.jpg")}>
                      <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        Lorem ipsum dolor sit amet.
                      </h5>
                      <p className="font-normal text-gray-700 dark:text-gray-400">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti reprehenderit cumque quos at fugiat inventore molestias culpa officiis quia tempora.
                      </p>
                    </Card>
                  </div>
                </div>

                <div className="col-span-1">
                  <div className="w-full">
                    <Card imgSrc={require("../../images/event-3.jpg")}>
                      <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        Lorem ipsum dolor sit amet.
                      </h5>
                      <p className="font-normal text-gray-700 dark:text-gray-400">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti reprehenderit cumque quos at fugiat inventore molestias culpa officiis quia tempora.
                      </p>
                    </Card>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="col-span-1">
                  <div className="w-full">
                    <Card imgSrc={require("../../images/event-1.jpg")}>
                      <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        Lorem ipsum dolor sit amet.
                      </h5>
                      <p className="font-normal text-gray-700 dark:text-gray-400">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti reprehenderit cumque quos at fugiat inventore molestias culpa officiis quia tempora.
                      </p>
                    </Card>
                  </div>
                </div>

                <div className="col-span-1">
                  <div className="w-full">
                    <Card imgSrc={require("../../images/event-2.jpg")}>
                      <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        Lorem ipsum dolor sit amet.
                      </h5>
                      <p className="font-normal text-gray-700 dark:text-gray-400">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti reprehenderit cumque quos at fugiat inventore molestias culpa officiis quia tempora.
                      </p>
                    </Card>
                  </div>
                </div>

                <div className="col-span-1">
                  <div className="w-full">
                    <Card imgSrc={require("../../images/event-3.jpg")}>
                      <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        Lorem ipsum dolor sit amet.
                      </h5>
                      <p className="font-normal text-gray-700 dark:text-gray-400">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti reprehenderit cumque quos at fugiat inventore molestias culpa officiis quia tempora.
                      </p>
                    </Card>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="col-span-1">
                  <div className="w-full">
                    <Card imgSrc={require("../../images/event-1.jpg")}>
                      <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        Lorem ipsum dolor sit amet.
                      </h5>
                      <p className="font-normal text-gray-700 dark:text-gray-400">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti reprehenderit cumque quos at fugiat inventore molestias culpa officiis quia tempora.
                      </p>
                    </Card>
                  </div>
                </div>

                <div className="col-span-1">
                  <div className="w-full">
                    <Card imgSrc={require("../../images/event-2.jpg")}>
                      <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        Lorem ipsum dolor sit amet.
                      </h5>
                      <p className="font-normal text-gray-700 dark:text-gray-400">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti reprehenderit cumque quos at fugiat inventore molestias culpa officiis quia tempora.
                      </p>
                    </Card>
                  </div>
                </div>

                <div className="col-span-1">
                  <div className="w-full">
                    <Card imgSrc={require("../../images/event-3.jpg")}>
                      <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        Lorem ipsum dolor sit amet.
                      </h5>
                      <p className="font-normal text-gray-700 dark:text-gray-400">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti reprehenderit cumque quos at fugiat inventore molestias culpa officiis quia tempora.
                      </p>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </Carousel>
        </div>
      </div>
    </div>
  );
}
